import { useState } from 'react';
import { useModifyFormData } from './useModifyFormData';

export function useSendForm({ methodName }: { methodName: string | undefined }) {
  const [modifiedData, setModifiedData] = useState<Record<string, string> | null>(null);

  const modifyData = useModifyFormData({
    isDevcode: methodName === 'devcode'
  });

  const sendForm = (formData: Record<string, string>) => {
    setModifiedData(modifyData(formData));
  };

  return { modifiedData, sendForm };
}
